import { render } from "./ButtonSeparator.vue?vue&type=template&id=2a8534e5&scoped=true"
import script from "./ButtonSeparator.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./ButtonSeparator.vue?vue&type=script&charset=utf-8&lang=js"

import "./ButtonSeparator.vue?vue&type=style&index=0&id=2a8534e5&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a8534e5"]])

export default __exports__